import type { HTMLAttributes } from 'react';

type Tone = 'neutral' | 'success' | 'warning' | 'danger' | 'info' | 'brand';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: Tone;
}

const TONE: Record<Tone, string> = {
  neutral: 'bg-bg-muted text-fg-subtle',
  success: 'bg-success/10 text-success',
  warning: 'bg-warning/10 text-warning',
  danger: 'bg-danger/10 text-danger',
  info: 'bg-info/10 text-info',
  brand: 'bg-brand-subtle text-brand-contrast',
};

export function Badge({ tone = 'neutral', className, ...rest }: BadgeProps): JSX.Element {
  const cls = [
    'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium',
    TONE[tone],
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');
  return <span className={cls} {...rest} />;
}
